import type { ComponentProps } from 'react'
import { cn } from '../lib/cn'

const roles = {
  body: 'text-sm leading-6',
  small: 'text-xs leading-5',
  label: 'text-xs font-semibold leading-5',
  caption: 'text-xs leading-5',
  eyebrow: 'text-xs font-semibold uppercase tracking-[0.14em]',
}
const tones = {
  default: 'text-foreground',
  muted: 'text-muted-foreground',
  accent: 'text-action',
  danger: 'text-danger-foreground',
}
export function Text({
  as: Root = 'p',
  variant = 'body',
  tone = 'default',
  className,
  ...props
}: ComponentProps<'p'> & {
  as?: 'p' | 'span' | 'div'
  variant?: keyof typeof roles
  tone?: keyof typeof tones
}) {
  return <Root data-slot="text" className={cn(roles[variant], tones[tone], className)} {...props} />
}
const sizes = {
  sm: 'text-xl',
  md: 'text-2xl sm:text-3xl',
  lg: 'text-3xl sm:text-4xl',
  display: 'text-4xl sm:text-5xl lg:text-6xl',
}
export function Heading({
  as: Root = 'h2',
  size = 'md',
  className,
  ...props
}: ComponentProps<'h2'> & {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  size?: keyof typeof sizes
}) {
  return (
    <Root
      data-slot="heading"
      className={cn(
        'font-heading font-normal leading-tight tracking-tight text-balance',
        sizes[size],
        className,
      )}
      {...props}
    />
  )
}
